export type EasterEgg =
  | "awoo"
  | "boop"
  | "cathode-signal"
  | "collar-check"
  | "good-pup"
  | "howl-signal"
  | "steel-yard-signal"
  | "treat";

const SEQUENCES: [EasterEgg, string[]][] = [
  ["good-pup", ["arrowup", "arrowup", "arrowdown", "arrowdown", "arrowleft", "arrowright", "arrowleft", "arrowright", "b", "a"]],
  ["boop", ["b", "o", "o", "p"]],
  ["awoo", ["a", "w", "o", "o"]],
  ["treat", ["t", "r", "e", "a", "t"]],
];

export function detectEasterEgg(keys: string[]): EasterEgg | null {
  return (
    SEQUENCES.find(([, sequence]) =>
      sequence.every((key, index) => keys.at(index - sequence.length) === key),
    )?.[0] ?? null
  );
}

export function themeEasterEgg(theme: string): EasterEgg | null {
  return (
    {
      cathode: "cathode-signal",
      howl: "howl-signal",
      "steel-yard": "steel-yard-signal",
    } satisfies Record<string, EasterEgg>
  )[theme] ?? null;
}
